import { Component, Input } from '@angular/core';
import { DefaultFormDialogComponent } from '../message/dialogs/default-form-dialog.component';
import { GaValidateService } from '../formly/ga-validate.service';
import { TranslationService } from '../translation/translation.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../formly/ga-formly.service';
import { IObject } from '../../../type_definitions/datatypes';

@Component({
  selector: 'company-group-addedit',
  templateUrl: '../message/dialogs/default-form-dialog.html'
})
export class CompanyGroupAddeditComponent extends DefaultFormDialogComponent {
  @Input() public model: IObject;

  constructor(
    validateService: GaValidateService,
    translationService: TranslationService,
    private formlyService: GaFormlyService
  ) {
    super(validateService, translationService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.fields = this.createFields();
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.anInput('name', 'Group name')
        .isRequired()
        .build(),
      this.formlyService.aTextarea('comments', 'Comments')
        .build()
    ];
  }
}